/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all TaxAccountant.
const deps = ['Person', 'Collection'];
const factory = function (Person, Collection) {
  let TaxAccountantCollection;
  return (TaxAccountantCollection = (function () {
    let defaultId;
    TaxAccountantCollection = class TaxAccountantCollection extends Collection {
      static initClass() {
        defaultId = 'tax_accountant';

        this.prototype.$id = defaultId;
        this.prototype.$resource = 'person';
        this.prototype.$type = Person;
      }

      $url() {
        // if the client ID is passed, grab only tax accountants assigned to client
        if (this.$storeId() !== defaultId) {
          return `${super.$url()}/tax_accountant/client/${this.$storeId()}`;
        }
        return `${super.$url()}/tax_accountant/`;
      }

      $init() {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }
    };
    TaxAccountantCollection.initClass();
    return TaxAccountantCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/person').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.taxAccountant', moduleDeps)
  .factory('TaxAccountantCollection', factory);
